import { ColumnDef } from '@tanstack/react-table'
import { OperatorDataResponse } from '../../types'
import { Button } from '@/common/ui/button'
import { Link } from 'react-router-dom'
import ToggleOperatorStatus from '../ToggleOperatorStatus'

export const getOperatorTableColumns =
	(): ColumnDef<OperatorDataResponse>[] => {
		const columns: ColumnDef<OperatorDataResponse>[] = [
			{
				accessorKey: 'username',
				header: 'ชื่อผู้ใช้งาน',
			},
			{
				accessorKey: 'createdAt',
				header: 'วันที่สร้าง',
				cell: ({ row }) => new Date(row.original.createdAt).toLocaleString(),
			},
			{
				accessorKey: 'updatedAt',
				header: 'วันที่แก้ไขล่าสุด',
				cell: ({ row }) => new Date(row.original.updatedAt).toLocaleString(),
			},
			{
				accessorKey: 'isActive',
				header: 'สถานะ',
				cell: ({ row }) => <ToggleOperatorStatus operator={row.original} />,
			},
			{
				header: 'Action',
				cell: ({ row }) => (
					<Button>
						<Link to={`/admin/update-operator/${row.original.id}`}>แก้ไข</Link>
					</Button>
				),
			},
		]

		return columns
	}
